import {AxiosResponse} from "axios";
// import { Employee } from "../types/kehadiran";
import {UserResponse} from "../types/user";
import httpRequestV2 from "./apiv2";

export const getProfile = async (): Promise<AxiosResponse<UserResponse>> => {
  return await httpRequestV2.get('employee/profile')
}